import every from 'lodash/every';
import { useMemo } from 'react';
import { useTargetingSettingsContext } from '../../context/TargetingSettingsContext.tsx';
import type { RequiredParamsType } from '../../context/types.ts';

export const useAllSectionsLoaded = () => {
  const state = useTargetingSettingsContext((state: RequiredParamsType | null) => state);

  return useMemo(() => {
    if (!state?.sections) return false;

    return every(state.sections, section => !section.isLoading);
  }, [state]);
};
